export function increasePagination(pageNumber: string) {
  if (typeof window !== "undefined" && window._data) {
    const _data = window._data as { pagination?: string };
    _data.pagination = pageNumber;
  }
}
